import makeFAIcon from "utils/makeFAIcon";

import { faSeedling, faHandshake, faGlobe } from "@fortawesome/free-solid-svg-icons";

export const UnderstandingIcon = makeFAIcon(faSeedling);
export const EngagementIcon = makeFAIcon(faHandshake);
export const ActionIcon = makeFAIcon(faGlobe);
